import { ofType } from "redux-observable";
import { merge } from "rxjs";
import { combineChecks } from "../../../guards/combineChecks";
import { guard } from "../../../guards/guard";
import { invert } from "../../../guards/invert";
import { pathEmpty } from "../../../guards/pathEmpty";
import { TypeActionShowMe } from "../../actionShowMe";
import { checkAllAcreProductionDoneAvailable } from "../../checks/checkAllAcreProductionDoneAvailable";
import { checkAnyAcreConstructionInProgressAvailable } from "../../checks/checkAnyAcreConstructionInProgressAvailable";
import { checkAnyAcreNotConstructingAvailable } from "../../checks/checkAnyAcreNotConstructingAvailable";
import { checkAnyAcreProductionInProgressAvailable } from "../../checks/checkAnyAcreProductionInProgressAvailable";
import { pathSelectAcreProductionDoneMaxLevelUseHumus } from "../../path/pathSelectAcreProductionDoneMaxLevelUseHumus";
import { pathSelectBuildingConstructionInProgress } from "../../path/pathSelectBuildingConstructionInProgress";
import { pathSelectAcreNotProducingMaxLevelUseHumus } from "./paths/pathSelectAcreNotProducingMaxLevelUseHumus";
import { pathSelectAcreProductionInProgressMaxLevelUseHumus } from "./paths/pathSelectAcreProductionInProgressMaxLevelUseHumus";
import { pathSelectBuildingInBuildMenuUseHumus } from "./paths/pathSelectBuildingInBuildMenuUseHumus";
export var epicShowMeUseHumus = function (action$, state$, deps) {
    // TODO: Could Naming be done based on shopCategory?
    var action1 = action$.pipe(ofType(TypeActionShowMe.QuestTaskUseHumus), guard(state$, deps, pathEmpty)([
        combineChecks([
            invert(checkAnyAcreNotConstructingAvailable),
            invert(checkAnyAcreConstructionInProgressAvailable),
        ])(pathSelectBuildingInBuildMenuUseHumus),
    ]));
    var action2 = action$.pipe(ofType(TypeActionShowMe.QuestTaskUseHumus), guard(state$, deps, pathEmpty)([
        combineChecks([
            invert(checkAnyAcreNotConstructingAvailable),
            checkAnyAcreConstructionInProgressAvailable,
        ])(pathSelectBuildingConstructionInProgress),
    ]));
    var action3 = action$.pipe(ofType(TypeActionShowMe.QuestTaskUseHumus), guard(state$, deps, pathEmpty)([
        combineChecks([
            checkAnyAcreNotConstructingAvailable,
            invert(checkAnyAcreProductionInProgressAvailable),
            invert(checkAllAcreProductionDoneAvailable),
        ])(pathSelectAcreNotProducingMaxLevelUseHumus),
    ]));
    var action4 = action$.pipe(ofType(TypeActionShowMe.QuestTaskUseHumus), guard(state$, deps, pathEmpty)([
        combineChecks([
            checkAnyAcreNotConstructingAvailable,
            invert(checkAnyAcreProductionInProgressAvailable),
            checkAllAcreProductionDoneAvailable,
        ])(pathSelectAcreProductionDoneMaxLevelUseHumus),
    ]));
    var action5 = action$.pipe(ofType(TypeActionShowMe.QuestTaskUseHumus), guard(state$, deps, pathEmpty)([
        combineChecks([
            checkAnyAcreNotConstructingAvailable,
            checkAnyAcreProductionInProgressAvailable,
        ])(pathSelectAcreProductionInProgressMaxLevelUseHumus),
    ]));
    return merge(action1, action2, action3, action4, action5);
};



//////////////////
// WEBPACK FOOTER
// ./src/features/show-me/quest-tasks/use-humus/epicShowMeUseHumus.ts
// module id = 2388
// module chunks = 3